import {ValueObject} from '@s-ui/domain'

import {ListSeoLinkValueObject} from './ListSeoLinkValueObject.js'
import {ListSeoMetaValueObject} from './ListSeoMetaValueObject.js'
import {ListSeoScriptValueObject} from './ListSeoScriptValueObject.js'

export class SeoHeadValueObject extends ValueObject {
  #title
  #meta
  #link
  #scripts

  constructor({title, meta, link, scripts}) {
    super()
    this.#title = title
    this.#meta = meta
    this.#link = link
    this.#scripts = scripts
  }

  static create({title, description, canonical, scripts}) {
    return new SeoHeadValueObject({
      title,
      meta: ListSeoMetaValueObject.create({description, isIndexable: true}),
      link: ListSeoLinkValueObject.create({canonical}),
      scripts: ListSeoScriptValueObject.create({value: scripts})
    })
  }

  get title() {
    return this.#title
  }

  get meta() {
    return this.#meta.value
  }

  get link() {
    return this.#link.value
  }

  get scripts() {
    return this.#scripts.value
  }

  get value() {
    return {
      title: this.#title,
      meta: this.#meta.value,
      link: this.#link.value,
      scripts: this.#scripts.value
    }
  }
}
